import charts from '../../charts.js';

const panels = {
	// stock score
	score: {
		panel: {
			name: 'score',
			height: charts.values.panelHeight,
		},
		yAxis: {
			max: 100,
			baseValue: 50,
			min: 0,
		},
		series: [
			{
				name: 'score',
				valueYField: 'score',
				title: 'Stock Score',
				legendValueText: '{valueY} ({signal})',
				fill: charts.colours.green,
				fillOpacity: 0,
				stroke: charts.colours.green,
				type: 'lineSeries',
				fills: {
					fillOpacity: 0.15,
					visible: true,
				},
				range: {
					value: 0,
					endValue: 50,
					color: charts.colours.red,
				}
			},
		],
	},

	// chaikin money flow
	ADL: {
		panel: {
			name: 'ADL',
			height: charts.values.panelHeight,
			title: 'Chaikin Money Flow',
		},
		series: [
			{
				name: 'chaikin',
				valueYField: 'chaikin',
				title: 'Chaikin Money Flow',
				type: 'lineSeries',
				numberFormatter: {
					numberFormat: '#.##a',
				},
			},
		],
	},

	// 14-day rsi
	RSI14: {
		panel: {
			name: 'RSI14',
			title: 'RSI14',
			height: charts.values.panelHeight,
			yAxis: {
				max: 100,
				min: 0,
			},
		},
		series: [
			{
				name: 'RSI14',
				valueYField: 'RSI14',
				title: 'RSI14',
				type: 'lineSeries',
			},
		],
	},

	// MACD historgram
	MACD: {
		panel: {
			name: 'MACD',
			height: charts.values.panelHeight,
			title: 'MACD',
		},
		series: [
			{
				name: 'MACDHistogram',
				valueYField: 'MACDHistogram',
				title: 'MACD Histogram',
				type: 'columnSeries',
				fill: charts.colours.lightgrey,
				stroke: charts.colours.lightgrey,
			},
			{
				stroke: charts.colours.blue,
				name: 'MACDEMA',
				valueYField: 'MACDEMA',
				title: 'Signal Line',
				type: 'lineSeries',
			},
			{
				name: 'MACD',
				valueYField: 'MACD',
				title: 'MACD',
				type: 'lineSeries',
			},
		],
	},

	// average true range
	ATR: {
		panel: {
			name: 'ATR',
			height: charts.values.panelHeight,
			title: 'Average True Range',
		},
		series: [
			{
				name: 'atr',
				valueYField: 'ATR',
				title: 'Average True Range',
				type: 'lineSeries',
			},
		],
	},

	// average directional index
	ADX: {
		panel: {
			name: 'ADX',
			height: charts.values.panelHeight,
			title: 'Average Directional Index',
		},
		series: [
			{
				stroke: charts.colours.black,
				name: 'adx',
				valueYField: 'ADX',
				title: 'Average Directional Index',
				type: 'lineSeries',
			},
			{
				stroke: charts.colours.green,
				name: 'plusDI',
				valueYField: 'plusDI',
				title: '+DI',
				type: 'lineSeries',
			},
			{
				stroke: charts.colours.red,
				name: 'minusDI',
				valueYField: 'minusDI',
				title: '-DI',
				type: 'lineSeries',
			},
		],
	},

	// volume
	volume: {
		panel: {
			name: 'volume',
			height: charts.values.panelHeight,
			title: 'Volume',
		},
		series: [
			{
				name: 'volume',
				valueYField: 'volume',
				title: 'Volume',
				fill: charts.colours.lightgrey,
				stroke: charts.colours.lightgrey,
				type: 'columnSeries',
			},
		],
	},
};

export default panels;
